// Path: libs/featureds/public/clients/src/lib/client-auth-ui.module.ts
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@cardapio-online/inputs';
import { AuthClientComponent } from './components/auth-client/auth-client.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputsModule],
  declarations: [AuthClientComponent],
  exports: [AuthClientComponent],
})
export class ClientAuthUiModule {}